<template>
  <div>
    <b-row align-v="stretch">
      <b-col v-if="!!clientTab.header_html || forceHeaderTab" :class="!!clientTab.header_html ? 'col-12 col-md-7 mb-2 pr-1' : 'mb-2'">
        <b-card class="h-100">
          <span v-if="busy">
            <i class="fa fa-fw fa-circle-notch fa-spin"></i>
            {{ trans('please_wait') }}
          </span>
          <div v-if="!busy" v-html="header_placeholders"></div>
          <div v-if="!busy && isClubTab">
              {{ trans('total_cost_of_affiliations') }} <small>({{ formFilterName }})</small>: <strong>{{ totalCostAffiliation }}</strong>
          </div>
        </b-card>
      </b-col>
      <b-col :class="!!clientTab.header_html ? 'col-12 col-md-5 mb-2 pl-1' : 'mb-2'">
        <b-card class="h-100">
          <strong class="d-block">
            {{ trans('access_to_submitted_forms') }}
          </strong>
          <ul>
            <li v-if="client.confirmed_emails.length > 0">
              {{ client.confirmed_emails.join(', ') }}
              <small class="text-muted" :title="trans('you_have_filled_using_your_email_address')" v-b-tooltip.hover>
                <i class="fa fa-fw fa-info-circle"></i>
              </small>
            </li>
            <li v-if="!!clientTabAccess">
              {{ clientTabAccess.label }}:
              {{ clientTabAccess.values.join(', ') }}
            </li>
          </ul>
          <p v-if="false" class="my-2">
            <b-button variant="link" size="sm" class="p-0" @click="onClickRequestAccess" :disabled="busy">
              {{ trans('request_access') }}
            </b-button>
          </p>
        </b-card>
      </b-col>
    </b-row>
    <b-card v-if="busy && organization.has_form_tracking_client_tabs && (!trackedItems || trackedItems.length == 0)" class="h-100 mb-2">
      <span>
        <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        {{ trans('please_wait') }}
      </span>
    </b-card>
    <b-card no-body class="mb-2" v-if="trackedItems && trackedItems.length > 0 && organization.has_form_tracking_client_tabs">
      <b-row class="mt-3 px-3 mb-1">
        <b-col>
          <p>
            <strong>{{ trans('tracked_forms') }}</strong>
          </p>
        </b-col>
        <b-col class="col-auto">
          <b-button variant="outline-secondary" size="sm" @click="refresh" :disabled="busy">
              <i :class="`fa fa-fw ${busy ? 'fa-circle-notch fa-spin' : 'fa-redo'}`"></i>
          </b-button>
        </b-col>
      </b-row>
      <b-table 
        id="tracked_forms"
        ref="table"
        class="bg-white table-row-click px-3"
        responsive
        small
        hover
        show-empty
        :fields="trackedFields"
        :items="trackedItems"
        @row-clicked="onRowClick"
      >
        <template #empty>
          <p align="center">
            <span v-if="!busy">{{ trans('none') }}</span>
            <span v-if="busy">
              <i class="fa fa-fw fa-circle-notch fa-spin"></i>
              {{ trans('please_wait') }}
            </span>
          </p>
        </template>
        <template #cell(name)="data">
          {{ data.value }}
          <i class="fa fa-fw fa-caret-right" v-if="!data.item._showDetails"></i>
          <i class="fa fa-fw fa-caret-down" v-if="data.item._showDetails"></i>
        </template>
        <template #cell(filled)="data">
          <span v-if="data.item.is_manual_track">
            <b-form-checkbox switch size="sm" v-model="data.item.filled" inline :disabled="busy" @change="onSwitchTrack(data.item)">
              {{ trans(data.item.filled ? 'yes' : 'no') }}
            </b-form-checkbox>
          </span>
          <span v-else>
            {{ data.value ? trans('yes') : trans('no') }}
          </span>
        </template>
        <template #cell(status)="data">
          {{ data.value }} <span class="ml-2 text-danger" v-if="getHasAdminNotes(data.item)"><i class="far fa-comment-dots"></i></span>
        </template>
        <template #cell(action)="data">
          <b-button
            variant="link"
            class="p-0 shadow-none"
            size="sm"
            :title="trans('fill_other_tab')"
            v-b-tooltip.hover.bottom
            @click="onFormLinkClick(data.item, data.index)"
          >
            <span>
              {{ trans('visit') }}
              <i class="fa fa-fw fa-external-link-alt"></i>
            </span>
          </b-button>
        </template>
        <template #row-details="data">
          <div class="px-2 mt-2">
            <div v-if="data.item.tracking_rule && data.item.status_answer" class="mb-2">
              <strong class="d-block">{{ trans('status') }}</strong>
              {{ data.item.status_answer.label }}: {{ data.item.status_answer.text || '' }}
              <hr>
            </div>
            <div v-if="getHasAdminNotes(data.item)" class="mb-2">
              <strong class="d-block">{{ trans('admin_notes') }}</strong>
              <div v-for="(note, ni) in data.item.admin_notes" :key="ni" class="mb-2">
                <b-row>
                  <b-col><span>{{ note.text }}</span></b-col>
                </b-row>
                <b-row>
                  <b-col><small class="text-muted">{{ moment(note.updated_at).format('LL') }}</small></b-col>
                </b-row>
              </div>
              <hr>
            </div>
            <em class="text-danger" v-if="data.item.filled_forms.length == 0">{{ trans('no_form_filled') }}</em>
            <div v-if="data.item.filled_forms.length > 0">
              <strong class="d-block">{{ trans('forms') }}</strong>
              <b-row v-for="(filled_form, index) in data.item.filled_forms" :key="filled_form.id" class="mb-2">
                <b-col class="col-auto">
                  <span>{{ filled_form.name ? filled_form.name : '' }}</span>
                  <b-link v-if="filled_form.extra && filled_form.extra.pdf_url"
                    :href="filled_form.extra.pdf_url"
                    target="_blank"
                  >
                    <i class="fa fa-fw fa-file-pdf"></i>
                  </b-link>
                  <small class="d-block">{{ filled_form.email ? filled_form.email : '' }}</small>
                </b-col>
                <b-col>
                  {{ moment(filled_form.filled_at).format('LLL') }}
                </b-col>
              </b-row>
            </div>
          </div>
        </template>
      </b-table>
    </b-card>
    <b-card no-body>
      <p class="mt-3 px-3 mb-1">
        <strong>{{ trans('filled_forms') }}</strong>
      </p>
      <b-row class="px-3 mb-3">
        <b-col>
          <b-dropdown variant="outline-branded" size="sm" class="mb-2" :disabled="busy">
            <template #button-content>
              <i class="fa fa-fw fa-file"></i>
              {{ formFilterName }} 
            </template>
            <b-dropdown-item @click="onClickFilter(null)">
              {{ trans('all') }}
            </b-dropdown-item>
            <b-dropdown-item v-for="f in recipientForms" :key="f.id" @click="onClickFilter(f)">
              {{ f.name }}
            </b-dropdown-item>
          </b-dropdown>
          <b-dropdown v-if="isClubTab && !!recipient_form" variant="outline-secondary" size="sm" class="ml-2 mb-2" :disabled="busy">
            <template #button-content>
              <span :class="!duplicates ? 'text-muted' : 'text-primary'">
                <i class="fa fa-fw fa-filter"></i>
                {{ filterLabel }}
              </span>
            </template>
            <b-dropdown-item @click="duplicates = false; onClickDuplicates()">
              <i :class="`fa fa-fw ${!duplicates ? 'fa-check' : ''}`"></i>
              {{ trans('all') }}
            </b-dropdown-item>
            <b-dropdown-item @click="duplicates = true; onClickDuplicates()">
              <i :class="`fa fa-fw ${duplicates ? 'fa-check' : ''}`"></i>
              {{ trans('duplicates') }}
            </b-dropdown-item>
          </b-dropdown>
          <b-button v-if="!!recipient_form" variant="branded" size="sm" class="ml-2 mb-2" @click="onClickAdd" :disabled="false">
            <i class="fa fa-fw fa-plus"></i>
            {{ trans('add') }}
          </b-button>
          <b-button v-if="!!recipient_form && recipient_form.pivot.allow_import" variant="branded" size="sm" class="ml-2 mb-2" @click="onClickImport" :disabled="busy">
            <i class="fa fa-fw fa-upload"></i>
            {{ trans('import') }}
          </b-button>
          <b-button v-if="!!downloadExcelUrl" variant="outline-success" size="sm" class="ml-2 mb-2" target="_blank" :href="downloadExcelUrl" :disabled="busy">
            <i class="fa fa-fw fa-file-excel"></i>
            {{ trans('export') }}
          </b-button>
          <b-button v-if="!!recipient_form" variant="outline-secondary" size="sm" class="ml-2 mb-2" v-b-modal.share-form-modal>
            <i class="fa fa-fw fa-link"></i>
            {{ trans('share') }}
          </b-button>
        </b-col>
        <b-col class="col-auto">
          <b-button variant="outline-secondary" size="sm" @click="refresh" :disabled="busy">
              <i :class="`fa fa-fw ${busy ? 'fa-circle-notch fa-spin' : 'fa-redo'}`"></i>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="px-3 mb-3">
        <b-col>
          <search-form
            v-model="search"
            size="sm"
            :name-placeholder="trans('name')"
            @input="onSearch"
            hide-email
            hide-mobile
            :disabled="busy"
          ></search-form>
        </b-col>
      </b-row>

      <b-table
        id="filled_forms"
        ref="table"
        class="bg-white"
        responsive
        show-empty
        :per-page="perPage"
        :current-page="currentPage"
        :fields="fields"
        :items="filteredItems"
      >
        <template #empty>
          <p align="center">
            <span v-if="!busy">{{ trans('none') }}</span>
            <span v-if="busy">
              <i class="fa fa-fw fa-circle-notch fa-spin"></i>
              {{ trans('please_wait') }}
            </span>
          </p>
        </template>
        <template #cell(name)="data">
          {{ data.value }}
          <small v-if="!!data.item.extra && !!data.item.extra.account_owner && (!showGender && !!data.item.extra.account_owner.gender || !showDateOfBirth && !!data.item.extra.account_owner.date_of_birth)" class="d-block">
            {{ compact([
              !!data.item.extra.account_owner.gender ? trans('gender_'+data.item.extra.account_owner.gender) : null,
              !!data.item.extra.account_owner.date_of_birth ? `${data.item.extra.account_owner.date_of_birth} (${moment().diff(moment(data.item.extra.account_owner.date_of_birth, 'YYYY-MM-DD'), 'years')})` : null
            ]).join(', ') }}
          </small>
          <small class="d-block">
            {{ compact([
              data.item.email,
              data.item.mobile,
            ]).join(', ') }}
          </small>
        </template>
        <template #cell(action)="data">
          <b-dropdown
            v-if="showActionsMenu(data.item)"
            variant="link"
            size="sm"
            class="p-0"
            toggle-class="text-muted"
            boundary="window"
            right
            :disabled="busy"
          >
            <template #button-content>
              <i class="fa fa-fw fa-ellipsis-h"></i>
            </template>
            <b-dropdown-item
              :href="maybeAddSession(`/org/${organization.id}/client/filled_form_pdf/${data.item.id}`, organization)"
              target="_blank"
            >
              <i class="fa fa-fw fa-file-pdf"></i>
              {{ trans('download_pdf') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canModify(data.item)"
              @click="onViewModifyClone($event, data.item)"
            >
              <i class="fa fa-fw fa-edit"></i>
              {{ trans('modify') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canClone(data.item)"
              @click="onViewModifyClone($event, data.item, true)"
            >
              <i class="fa fa-fw fa-copy"></i>
              {{ trans('duplicate') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canDelete(data.item)"
              @click="onClickDelete($event, data.item)"
            >
              <span class="text-danger">
                <i class="fa fa-fw fa-trash"></i>
                {{ trans('delete') }}
              </span>
            </b-dropdown-item>
          </b-dropdown>
          <b-link
            v-if="!showActionsMenu(data.item)"
            :href="maybeAddSession(`/org/${organization.id}/client/filled_form_pdf/${data.item.id}`, organization)"
            target="_blank"
            :title="trans('download_pdf')"
          >
            <i class="fa fa-fw fa-file-pdf"></i>
          </b-link>
        </template>
        <template #cell(extra.account_owner.gender)="data">
          <small>{{ data.value }}</small>
        </template>
        <template #cell(extra.account_owner.date_of_birth)="data">
          <small>{{ data.value }}</small>
        </template>
        <template #cell(children)="data">
          <small class="d-block" v-for="(child, index) in data.value" :key="index">
            {{
              compact([
                child.name,
                child.gender ? trans('gender_'+child.gender) : null,
                child.date_of_birth ? `${child.date_of_birth} (${moment().diff(child.date_of_birth, 'years')})` : null,
                child.grade ? `${trans('grade')} ${child.grade}` : null,
                child.email,
                child.mobile
              ]).join(', ')
            }}
          </small>
        </template>
        <template #cell(participant)="data">
          {{ data.value.name }}
          <small>
            {{
              compact([
                data.value.name,
                data.value.gender ? trans('gender_'+data.value.gender) : null,
                data.value.date_of_birth ? `${data.value.date_of_birth} (${moment().diff(data.value.date_of_birth, 'years')})` : null,
              ]).join(', ')
            }}
          </small>
        </template>
        <template #cell(media_answers)="data">
          <div v-for="answer in data.value" :key="answer.id" class="mb-2">
            <small class="d-block text-muted">{{ answer.label }}</small>
            <div v-for="media in answer.json" :key="media.umid">
              <b-button v-if="answer.type == 'images'" :href="mediaUrl(answer, media.umid)" target="_blank" variant="link" size="sm" class="p-0 text-left">
                <i class="fa fa-fw fa-image"></i> {{ media.name }}
              </b-button>
              <b-button v-if="answer.type == 'videos' && !media.deleted_at" @click="onClickVideo(answer, media)" variant="link" size="sm" class="p-0 text-left">
                <i class="fa fa-fw fa-video"></i> {{ media.name }}
              </b-button>
            </div>
          </div>
        </template>
        <template #cell(borough)="data">
          <small class="d-block">{{ data.value }}</small>
        </template>
        <template #cell(sport)="data">
          <small class="d-block">{{ data.value }}</small>
        </template>
        <template #cell(filled_at)="data">
          <small class="d-block">{{ data.value }}</small>
        </template>
        <template #cell()="data">
          <span v-if="typeof data.value != 'object'">
            {{ data.value }}
          </span>
          <small
            v-if="typeof data.value == 'object' && data.value.length > 0"
            v-for="(v, index) in data.value"
            :key="'v_'+index"
            class="d-block"
          >
            {{ v }}
          </small>
        </template>
      </b-table>
      <b-row class="px-3 mb-2">
        <b-col class="pt-1">
          <small>
            {{ itemCount }}
            {{ trans('form_submission' + (itemCount > 1 || itemCount == 0 && lang == 'en' ? 's' : '')).toLowerCase() }}
          </small>
        </b-col>
        <b-col>
          <b-pagination
            :total-rows="filteredItems.length"
            :per-page="perPage"
            v-model="currentPage"
            aria-controls="filled_forms"
            align="center"
            size="sm"
          ></b-pagination>
        </b-col>
        <b-col>
          <b-form-group class="text-right">
            <b-form-select v-model="perPage" size="sm" class="w-50" :options="perPageOptions" :disabled="busy" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <client-form-iframe-modal
      :organization="organization"
      :upid="item ? item.recipient_form_upid : null"
      :urid="item ? item.urid || null : null"
      :title="trans(!!item && !!item.urid ? 'modify' : 'new')"
      @hidden="refresh"
    ></client-form-iframe-modal>
    <form-import-modal
      :organization="organization"
      :recipient_form="recipient_form"
      :client="client"
      :client-tab="clientTab"
      @imported="refresh"
    ></form-import-modal>

    <b-modal
      id="share-form-modal"
      :title="trans('share_form')"
      :ok-title="trans('close')"
      ok-only
    >
      <b-form-group v-if="!!recipient_form" :title="trans('shareable_link')">
        <b-input-group>
          <b-form-input v-model="recipient_form.page_url" size="sm" readonly></b-form-input>
          <b-input-group-append>
            <b-button variant="outline-primary" size="sm" v-clipboard:copy="recipient_form.page_url" :title="trans('copy')" v-b-tooltip.hover class="px-2">
              <i class="fa fa-fw fa-copy"></i>
            </b-button>
            <a :href="maybeAddSession(recipient_form.page_url, organization)" target="_forms" class="btn btn-outline-primary btn-sm px-2" :title="trans('visit')" v-b-tooltip.hover>
              <i class="fa fa-fw fa-external-link-alt"></i>
            </a>
          </b-input-group-append>
        </b-input-group>
        <b-form-text>
          {{ trans('shareable_link_about') }}
        </b-form-text>
      </b-form-group>
    </b-modal>

    <b-modal
      id="filled-forms-video-modal"
      :title="media ? media.name : null"
      ok-only
      :ok-title="trans('close')"
      size="lg"
    >
      <div v-if="!!media">
        <video
          :src="media.url"
          controls
          class="w-100"
        />
      </div>
      <div v-if="!!media">
        <b-button variant="link" size="sm" class="text-muted" @click="video_only_audio = !video_only_audio">
          <i class="fa fa-fw fa-info-circle"></i>
          {{ trans('video_only_audio') }}
        </b-button>
        <b-alert variant="danger" :show="video_only_audio" class="mx-2">
          {{ trans('video_only_audio_note') }}
        </b-alert>
        <b-img v-if="video_only_audio" :src="downloadVideoInstructionsImageUrl" fluid />
      </div>
      <div v-if="!media">
        <p class="lead text-center my-4">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          {{ trans('please_wait') }}
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import ClientFormIframeModal from './ClientFormIframeModal'
  import FormImportModal from './../form/FormImportModal'
  import SearchForm from './../../../common/components/SearchRecipientsForm'

  function hasThing(value, things) {
    if (!value) return false
    value = value.toLowerCase()
    return _.reduce(things, (has, thing) => {
      if (value.indexOf(thing.toLowerCase()) >= 0) has = true
      return has
    }, false)
  }

  const forceHeaderTabIds = [29]; // forcing header tab for Gym QC club tab

  export default {
    props: {
      organization: Object,
      client: Object,
      clientTab: Object,
    },
    components: {
      ClientFormIframeModal,
      FormImportModal,
      SearchForm,
    },
    data() {
      return {
        trans: trans,
        lang: lang,
        compact: _.compact,
        moment: moment,
        maybeAddSession: _.maybeAddSession,
        busy: false,
        error: null,
        items: null,
        filteredItems: [],
        item: null,
        recipient_form: null,
        perPage: 10,
        currentPage: 1,
        media: null,
        video_only_audio: false,
        header_placeholders: null,
        search: {
          name: null,
          email: null,
          mobile: null,
        },
        duplicates: false,
        trackedItems: [],
        has_tracking_rule: false,
        has_admin_notes: false,
      }
    },
    computed: {
      recipientForms() {
        return this.clientTab.recipient_forms || []
      },
      formFilterName() {
        if (!this.recipient_form) return trans('all')
        return this.recipient_form.name
      },
      clientTabAccess() {
        return _.reduce(this.client.client_tab_accesses || [], (found, a) => {
          if (a.id == this.clientTab.id) found = a
          return found
        }, null)
      },
      itemCount() {
        return this.filteredItems.length
      },
      hasDifferentRespondent() {
        return _.reduce(this.items || [], (has, item) => {
          if (this.client.emails.indexOf(item.email) === -1) has = true
          return has
        }, false)
      },
      hasChildren() {
        return _.reduce(this.items || [], (has, item) => {
          if (item.children && item.children.length > 0) has = true
          return has
        }, false)
      },
      hasParticipant() {
        return _.reduce(this.items || [], (has, item) => {
          if (!!item.participant) has = true
          return has
        }, false)
      },
      hasMedia() {
        return _.reduce(this.items || [], (has, item) => {
          if (item.media_answers && item.media_answers.length > 0) has = true
          return has
        }, false)
      },
      recipientSelectQuestions() {
        let question_ids = []
        return _.reduce(this.items || [], (questions, item) => {
          return _.reduce(item.recipients_select_answers || [], (questions, a) => {
            if (question_ids.indexOf(a.question_id) == -1) {
              questions.push({
                id: a.question_id,
                type: a.type,
                slug: a.slug,
                label: a.label
              })
              question_ids.push(a.question_id)
            }
            return questions
          }, questions)
        }, [])
      },
      hasRecipientsSelect() {
        return this.recipientSelectQuestions.length > 0
      },
      accountOwnerAttributes() {
        return _.reduce(this.items || [], (attributes, item) => {
          if (!!item.extra && !!item.extra.account_owner) {
            if (item.extra.account_owner.gender &&
              attributes.indexOf('gender') === -1)
              attributes.push('gender')
            if (item.extra.account_owner.date_of_birth &&
              attributes.indexOf('date_of_birth') === -1)
              attributes.push('date_of_birth')
          }
          return attributes
        }, ['name'])
      },
      showGender() {
        return !!this.recipient_form && this.accountOwnerAttributes.indexOf('gender') >= 0
      },
      showDateOfBirth() {
        return !!this.recipient_form && this.accountOwnerAttributes.indexOf('date_of_birth') >= 0
      },
      fields() {
        let fields = []

        if (!this.recipient_form) {
          fields.push({
            key: 'recipient_form_name',
            label: trans('form'),
          })
        }

        if (!!this.clientTab.caa_key_form_question) {
          fields.push({
            key: 'caa_value',
            label: this.clientTab.caa_key_form_question.label,
            sortable: true,
          })
        }

        if (!!this.clientTab.show_columns_from_placeholder_names &&
          this.clientTab.show_columns_from_placeholder_names.length > 0) {
          _.each(this.clientTab.show_columns_from_placeholder_names, placeholder => {
            fields.push({
              key: 'placeholder_answers.'+placeholder,
              label: placeholder,
              sortable: true,
            })
          })
        }

        fields.push({
          key: 'name',
          label: trans('name'),
          formatter(value, key, item) {
            if (!!item.extra &&
              !!item.extra.account_owner &&
              !!item.extra.account_owner.company)
              return _.compact([value, item.extra.account_owner.company]).join(', ')
            return value
          },
          sortable: true,
        })
        if (this.showGender) {
          fields.push({
            key: 'extra.account_owner.gender',
            label: trans('gender'),
            formatter(value, key, item) {
              if (!value) return null
              return trans('gender_'+value)
            },
            sortable: true,
          })
        }
        if (this.showDateOfBirth) {
          fields.push({
            key: 'extra.account_owner.date_of_birth',
            label: trans('date_of_birth'),
            sortable: true,
          })
          fields.push({
            key: 'extra.account_owner.age',
            label: trans('age'),
            sortable: true,
          })
        }

        if (this.hasMedia) {
          fields.push({
            key: 'media_answers',
            label: trans('media'),
          })
        }

        if (this.hasRecipientsSelect) {
          fields = _.reduce(this.recipientSelectQuestions, (fields, q) => {
            fields.push({
              key: 'q'+q.id,
              label: q.label,
              formatter(value, key, item) {
                return _.reduce(item.recipients_select_answers || [], (recipients, a) => {
                  if ('q'+a.question_id == key && !!a.text) {
                    recipients = a.text.split('\n')
                  }
                  return recipients
                }, [])
              },
            })
            return fields
          }, fields)
        }

        fields.push({
          key: 'filled_at',
          label: trans('date'),
          formatter(value) {
            return moment(value).format('LLL')
          },
          sortable: true,
          sortDirection: 'desc',
        })
        fields.push({key: 'action', label: trans('operation')})
        return fields
      },
      trackedFields() {
        let fields = []
        fields.push({
          key: 'name',
          label: trans('form'),
          sortable: true
        })
        fields.push({
          key: 'filled',
          label: trans('filled'),
          sortable: true,
        })
        if (this.has_tracking_rule || this.has_admin_notes) {
          fields.push({
            key: 'status',
            label: trans('status'),
            sortable: true,
          })
        }
        fields.push({
          key: 'action',
          label: '',
        })
        return fields
      },
      downloadExcelUrl() {
        if (!this.recipient_form || this.recipient_form.type == 'payment_form') return null
        return _.maybeAddSession(`/org/${this.organization.id}/client/tab/${this.clientTab.id}/form/${this.recipient_form.id}/excel`, this.organization)
      },
      perPageOptions() {
        let options = [
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100},
        ]
        return options
      },
      downloadVideoInstructionsImageUrl() {
        return `https://activitymessenger-assets-ca.s3.ca-central-1.amazonaws.com/help/video-not-playing-${window.lang}.png`
      },

      // for GymQC total cost of affiliation
      totalCostAffiliation() {
        let total = 0
        if (!this.items || this.items.length == 0) total = 0
        else {
          total = _.sumBy(this.items, item => _.toNumber(item.cost_of_affiliation ?? 0))
        }
        return _.currency(total)
      },
      forceHeaderTab() {
        return _.includes(forceHeaderTabIds, this.clientTab.id)
      },
      isClubTab() {
        return this.clientTab.id == 29 && this.organization.id == 1426
      },
      filterLabel() {
        let label = trans('all')
        if (this.duplicates) label = trans('duplicates')
        return label
      },
    },
    methods: {
      onSearch() {
        if (!this.search.name) {
          this.filteredItems = this.items || []
          return
        }
        let term = this.search.name.toLowerCase().trim()
        this.filteredItems = _.reduce(this.items, (result, item) => {
          let name = !!item.extra && !!item.extra.account_owner ?
            _.compact([item.extra.account_owner.name, item.extra.account_owner.company]).join(', ') :
            item.name
          if (!name) return result
          name = name.toLowerCase().trim()
          if (name.indexOf(term) >= 0) result.push(item)
          return result
        }, [])
      },
      onClickRequestAccess() {
        this.item = {
          recipient_form_upid: this.clientTab.caa_recipient_form.upid,
          urid: null,
        }
        this.$bvModal.show('client-form-iframe-modal')
      },
      canModify(item) {
        return _.reduce(this.clientTab.recipient_forms, (allowed, form) => {
          if (form.id == item.recipient_form_id && form.pivot.allow_modify) allowed = true
          return allowed
        }, false)
      },
      canClone(item) {
        if (!this.clientTab) return false
        return _.reduce(this.clientTab.recipient_forms, (allowed, form) => {
          if (form.id == item.recipient_form_id && form.pivot.allow_clone) allowed = true
          return allowed
        }, false)
      },
      canDelete(item) {
        return _.reduce(this.clientTab.recipient_forms, (allowed, form) => {
          if (form.id == item.recipient_form_id && form.pivot.allow_archive) allowed = true
          return allowed
        }, false)
      },
      showActionsMenu(item) {
        return this.canModify(item) || this.canClone(item) || this.canDelete(item)
      },
      onClickVideo(answer, media) {
        this.media = _.assign({}, media, {url: this.mediaUrl(answer, media.umid)})
        this.$bvModal.show('filled-forms-video-modal')
      },
      mediaUrl(answer, umid) {
        return _.maybeAddSession(`/org/${this.organization.id}/client/answer/${answer.id}/media/${umid}`, this.organization)
      },
      onClickFilter(item) {
        this.recipient_form = item
        this.fetch()
      },
      onClickAdd() {
        this.item = {
          recipient_form_upid: this.recipient_form.upid
        }
        this.$bvModal.show('client-form-iframe-modal')
      },
      onClickImport() {
        this.$bvModal.show('form-import-modal')
      },
      onClickDuplicates() {
        if (this.duplicates) {
          // find duplicates based on name and dob
          const keyGenerator = item => `${item.extra.account_owner.date_of_birth}_${item.name}`
          let keyCounts = _.countBy(this.filteredItems, keyGenerator) // group items by the generated keys
          let duplicateKeys = _.keys(_.pickBy(keyCounts, count => count > 1)) // only get the keys that appear more than once
          this.filteredItems = _.filter(this.filteredItems, item => // filter array using the key gen
            _.includes(duplicateKeys, keyGenerator(item)) 
          )
        }
        else this.filteredItems = this.items || []
      },
      onClickDelete(e, item) {
        e.preventDefault()
        let message = trans('delete_confirm')
        if (this.hasClass) message = trans('delete_confirm')
        this.$bvModal.msgBoxConfirm(message, {
          title: item.participant ? item.participant.name : '',
          okTitle: trans('delete'),
          okVariant: 'danger',
          cancelTitle: trans('cancel'),
        })
        .then(confirmed => {
          if (!confirmed) return
          const url = `/org/${this.organization.id}/client/filled_forms/${item.recipient_id}`
          axios.delete(url)
          .then(response => {
            this.$bvToast.toast(response.data.message, {
              title: trans('success'),
              variant: 'success',
              solid: true,
            })
            this.refresh()
          })
          .catch(error => {
            this.error = _.errorFromAjax(error)
            _.toastError(this, this.error)
          })
        })
      },
      onViewModifyClone(e, item, clone) {
        e.preventDefault()
        this.item = item

        if (this.item.urid) {
          this.$bvModal.show('client-form-iframe-modal')
          return
        }

        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/${clone ? 'urid_for_cloned_recipient' : 'urid_for_recipient'}/${this.item.recipient_id}`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.$set(this.item, 'urid', response.data.urid)
          this.$bvModal.show('client-form-iframe-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
        })
      },
      onFormLinkClick(item) {
        let url = item.page_url + `?c=${this.client.id}&p=${this.client.recipient_id}`
        window.open(url)
      },
      onRowClick(item, index) {
        item._showDetails = !item._showDetails
        this.$refs.table.refresh()
      },
      onSwitchTrack(item, index) {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/tracked_forms/${this.clientTab.id}/${item.ctrl_id}`
        return axios.patch(url, {filled: item.filled})
        .then(response => {
          this.busy = false
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
        })
      },
      refresh() {
        this.fetch()
        this.fetchTrackedForms()
      },
      getHeaderPlaceholders() {
        if (!this.clientTab.header_html) return null;
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/${this.client.id}/tab/${this.clientTab.id}/get_header_placeholders`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.header_placeholders = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
        })
      },
      process(data) {
        return _.map(data, item => {
          if (!!item.extra && !!item.extra.account_owner) {
            item.extra.account_owner.age = !!item.extra.account_owner.date_of_birth ?
              moment().diff(moment(item.extra.account_owner.date_of_birth, 'YYYY-MM-DD'), 'years') :
              null
          }
          return item
        })
      },
      fetch() {
        this.busy = true
        this.error = null
        this.items = null
        let query = `?page=${this.currentPage}&per_page=${this.perPage}`
        if (this.recipient_form) query += `&recipient_form_id=${this.recipient_form.id}`
        let url = `/org/${this.organization.id}/client/filled_forms/${this.clientTab.id}${query}`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.items = this.process(response.data)
          this.onSearch()
          this.onClickDuplicates()
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
          this.items = []
          this.onSearch()
          this.onClickDuplicates()
        })
      },
      fetchTrackedForms() {
        if (!this.organization.has_form_tracking_client_tabs) {
          return []
        }
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/tracked_forms/${this.clientTab.id}`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.trackedItems = this.processTracked(response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
          this.trackedItems = []
        })
      },
      processTracked(data) {
        return _.map(data, item => {
          const id = item.recipient_list_id
          item.filled_forms = _.filter(this.items, { recipient_form_id: id })
          if (item.is_manual_track) {
            item.filled = item.manual_filled
          }
          else {
            item.filled = item.filled_forms.length > 0
          }
          if (item.tracking_rule) this.has_tracking_rule = true
          if (item.admin_notes?.length > 0) this.has_admin_notes = true
          return item
        });
      },
      getHasAdminNotes(item) {
        if (item.admin_notes && item.admin_notes.length > 0) return true
        return false
      }
    },
    watch: {
      items() {
        if (this.items && this.items.length > 0) {
          this.trackedItems = this.processTracked(this.trackedItems)
        }
      }
    },
    mounted() {
      window['clientTab_'+this.clientTab.name] = this
      this.fetch()
      this.fetchTrackedForms()
      this.getHeaderPlaceholders()
    },
  }
</script>